<div class="physicalLocation">
  <div class="modal-header modalHeaderBlack">
    <h6 class="modal-title">{{ "adt.patientLocation" | translate }}</h6>
    <span
      aria-label="Close"
      class="close"
      (click)="onClick()"
      data-automation-attribute="span-close-dialog"
    >
      <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}"
        >clear</mat-icon
      >
    </span>
  </div>
  <form [formGroup]="formPhysicalLocation">
    <mat-card>
      <mat-card-content>
        <div class="form-field-container">
          <label for="wing">Wing:</label>
          <input matInput formControlName="wing" id="wing" readonly />
        </div>
        <div class="form-field-container">
          <label for="block">Block:</label>
          <input matInput formControlName="block" id="block" readonly />
        </div>
        <div class="form-field-container">
          <label for="floor">Floor:</label>
          <input matInput formControlName="floor" id="floor" readonly />
        </div>
        <div class="form-field-container">
          <label for="ward">Ward:</label>
          <input matInput formControlName="ward" id="ward" readonly />
        </div>
        <div class="form-field-container">
          <label for="room">Room:</label>
          <input matInput formControlName="room" id="room" readonly />
        </div>
        <div class="form-field-container">
          <label for="bed">Bed:</label>
          <input matInput formControlName="bed" id="bed" readonly />
        </div>
        <div class="form-field-container">
          <label for="bedCategory">Bed Category:</label>
          <input
            matInput
            formControlName="bedCategory"
            id="bedCategory"
            readonly
          />
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>
